export const parseWithUnit = (value: number | null, unit: string) => {
  if (value === null) {
    return '';
  }
  return `${value}${unit}`;
};
